"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileMetadata = void 0;
var media_platform_1 = require("../../../types/media-platform/media-platform");
var audio_basic_metadata_1 = require("./audio-basic-metadata");
var audio_extra_metadata_1 = require("./audio-extra-metadata");
var file_descriptor_1 = require("./file-descriptor");
var image_basic_metadata_1 = require("./image-basic-metadata");
var image_features_1 = require("./image-features");
var video_basic_metadata_1 = require("./video-basic-metadata");
var FileMetadata = /** @class */ (function () {
    function FileMetadata(data) {
        this.fileDescriptor = null;
        this.mediaType = null;
        this.basic = null;
        this.features = null;
        this.extra = null;
        if (!data.fileDescriptor) {
            return;
        }
        this.fileDescriptor = new file_descriptor_1.FileDescriptor(data.fileDescriptor || undefined);
        this.mediaType = data.mediaType || null;
        if (data.basic) {
            switch (this.mediaType) {
                case media_platform_1.MediaType.Image:
                    this.basic = new image_basic_metadata_1.ImageBasicMetadata(data.basic);
                    break;
                case media_platform_1.MediaType.Video:
                    this.basic = new video_basic_metadata_1.VideoBasicMetadata(data.basic);
                    break;
                case media_platform_1.MediaType.Audio:
                    this.basic = new audio_basic_metadata_1.AudioBasicMetadata(data.basic);
                    break;
                // TODO
                // case MediaType.Font:
                //   this.basic = new FontBasicMetadata(
                //       data.basic as IFontBasicMetadata,
                //   );
                //   break;
                default:
                    return;
            }
        }
        if (data.features) {
            switch (this.mediaType) {
                case media_platform_1.MediaType.Image:
                    this.features = new image_features_1.ImageFeatures(data.features);
                    break;
                default:
                    return;
            }
        }
        if (data.extra) {
            switch (this.mediaType) {
                case media_platform_1.MediaType.Audio:
                    this.extra = new audio_extra_metadata_1.AudioExtraMetadata(data.extra);
                    break;
                default:
                    return;
            }
        }
    }
    return FileMetadata;
}());
exports.FileMetadata = FileMetadata;
//# sourceMappingURL=file-metadata.js.map